import { render, staticRenderFns } from "./TransportationVolumes.vue?vue&type=template&id=2176a545&scoped=true"
import script from "./TransportationVolumes.vue?vue&type=script&lang=js"
export * from "./TransportationVolumes.vue?vue&type=script&lang=js"
import style0 from "./TransportationVolumes.vue?vue&type=style&index=0&id=2176a545&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2176a545",
  null
  
)

export default component.exports